import React from 'react';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { GenericSelect } from 'web-ui-components/lib/data/capture';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';
import { PERSONAL_TITLE_OTHER_DATA } from '../utils/personaDetailsUtils';

const TitleOther = () => (
  <Content>
    {({ accountDetailsFormErrorSelect = '' }) => (
      <Field name="titleOther" subscription={{ touched: true, error: true }} validate={isRequired}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId="titleOther"
            validationMessage={touched && !!error ? accountDetailsFormErrorSelect : ''}
          >
            <Field name="titleOther" validate={isRequired} component="select">
              {({ input }) => (
                <GenericSelect
                  name="titleOther"
                  {...input}
                  items={PERSONAL_TITLE_OTHER_DATA}
                  selectedId={!input.value ? null : input.value}
                  onChange={selectedId => {
                    input.onChange(selectedId);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default TitleOther;
